<template>
  <div>
    <NavigationHeader />
    <div class="error-wrapper">
      <div class="block">
        <span class="msg">{{ $t(`errorPage.code.${error.statusCode}`) }}</span>
        <span class="status">{{ error.statusCode }}</span>
        <GeneralElementsButton
          type="blue"
          :label="$t('errorPage.back')"
          @clicked="handleError"
        />
      </div>
      <NuxtImg
        src="/images/error.png"
        loading="lazy"
        format="webp"
        :alt="$t(`errorPage.code.${error.statusCode}`)"
      />
    </div>
    <NavigationFooter />
  </div>
</template>

<script setup>
  defineProps({
    error: {
      type: Object,
      required: true
    }
  })
  const handleError = () => clearError({ redirect: '/' })
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';
  .wrapper {
    max-width: 1120px;
    margin: 0 auto;
    position: relative;
  }

  img {
    width: 100%;
  }

  .error-wrapper {
    max-width: 1120px;
    margin: 0 auto;
    position: relative;
    top: 0;
    left: 0;
  }
  .block {
    padding: 40px 35px;
    text-align: center;

    @include tablet-up {
      position: absolute;
      background: $white;
      top: 24px;
      left: 24px;
      border-radius: 8px;
      max-width: 385px;
      box-sizing: border-box;
      padding: 18px 40px;
      overflow-y: auto;
      overflow-x: hidden;
      min-height: 245px;
    }
  }

  .msg {
    font-weight: 400;
    font-size: rem(16);
    line-height: 24px;
    text-align: center;
    color: $secondary;
    margin-bottom: 16px;
    display: block;
  }

  .status {
    display: block;
    text-align: center;
    font-weight: 700;
    font-size: 80px;
    line-height: 80px;
    color: $secondary;
    opacity: 0.5;
    margin-bottom: 16px;
  }

  .button {
    width: calc(100% - 24px);
    margin: 0 auto;
    max-width: 246px;
  }
</style>
